import _defineProperty from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import merge from 'lodash/merge';
import { NextSeo } from 'next-seo';
import React from 'react';
import { getSeoImage, seoConfig } from '../../lib/config/next-seo.config';
import { getBrowserInfo } from '@yalendar/shared/ui-core';

/**
 * Build full seo tags from title, desc, canonical and url
 */
var buildSeoMeta = function buildSeoMeta(pageProps) {
  var title = pageProps.title,
      description = pageProps.description,
      image = pageProps.image,
      canonical = pageProps.canonical,
      _pageProps$siteName = pageProps.siteName,
      siteName = _pageProps$siteName === void 0 ? seoConfig.headSeo.siteName : _pageProps$siteName;
  return {
    title: title,
    canonical: canonical,
    openGraph: {
      site_name: siteName,
      type: 'website',
      title: title,
      description: description,
      images: [{
        url: image //width: 1077,
        //height: 565,
        //alt: "Alt image"

      }]
    },
    additionalMetaTags: [{
      property: 'name',
      content: title
    }, {
      property: 'description',
      content: description
    }, {
      name: 'description',
      content: description
    }, {
      property: 'image',
      content: image
    }]
  };
};

var constructImage = function constructImage(name, avatar, description, showDescriptionInOgImage) {
  return encodeURIComponent("".concat(name, " ").concat(showDescriptionInOgImage ? "<br> ".concat(description) : '')).replace(/'/g, '%27') + '.png?md=1&images=https%3A%2F%2Fkreezus.com%2Fwp-content%2Fuploads%2F2022%2F01%2Fyalendar.com-white-1.svg&images=' + encodeURIComponent(avatar);
};

export var HeadSeo = function HeadSeo(props) {
  var _getBrowserInfo;

  var defaultUrl = (_getBrowserInfo = getBrowserInfo()) === null || _getBrowserInfo === void 0 ? void 0 : _getBrowserInfo.url;
  var image = getSeoImage('default');
  var title = props.title,
      description = props.description,
      _props$name = props.name,
      name = _props$name === void 0 ? null : _props$name,
      _props$avatar = props.avatar,
      avatar = _props$avatar === void 0 ? null : _props$avatar,
      siteName = props.siteName,
      _props$canonical = props.canonical,
      canonical = _props$canonical === void 0 ? defaultUrl : _props$canonical,
      _props$nextSeoProps = props.nextSeoProps,
      nextSeoProps = _props$nextSeoProps === void 0 ? {} : _props$nextSeoProps,
      _props$showDescriptio = props.showDescriptionInOgImage,
      showDescriptionInOgImage = _props$showDescriptio === void 0 ? false : _props$showDescriptio;
  var pageTitle = title + ' | Yalendar.com';
  var defaultImage = avatar || image;
  var seoObject = buildSeoMeta({
    title: pageTitle,
    image: defaultImage,
    description: description,
    canonical: canonical,
    siteName: siteName
  });

  if (name && avatar) {
    var pageImage = getSeoImage('ogImage') + constructImage(name, avatar, description, showDescriptionInOgImage);
    seoObject = buildSeoMeta({
      title: pageTitle,
      description: description,
      image: pageImage,
      canonical: canonical,
      siteName: siteName
    });
  }

  var seoProps = merge(nextSeoProps, seoObject);
  return /*#__PURE__*/_jsx(NextSeo, _objectSpread({}, seoProps));
};